<template>
  <div>
    <div style="margin:0 auto;text-align:center;">
      <h1>Coming Soon</h1>
      <p style="margin-top:50px;">You can download apps：</p>
      <div>
        <img src="@/assets/images/wineexpressQR.png" width="180" />
      </div>
      <div class="app-title">
        <img src="@/assets/images/iOS.png" width="20" alt="" />
        <a
          href="https://apps.apple.com/hk/app/wine-express/id428226718"
          target="_blank"
          style="text"
          >Wine Express</a
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
a {
  text-decoration: underline;
}
.app-title {
  img {
    margin: 0 5px;
  }
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 40px;
}
</style>
